import React, { useState, useEffect} from 'react'
import Form from 'react-bootstrap/Form'
import logoZap from '../img/WhatsAppButtonWhiteMedium.png'

const FormCliente = (props)=>{
  const { url } = props
  const [clienteName, setClienteName ] = useState('')
  const [clienteTelefone, setClienteTelefone ] = useState('')

  const changeCliente = (e)=>{
    const name = e.target.name
    const value = e.target.value
    if (name === 'nome') {
      setClienteName(value)
    }
    if (name === 'telefone') {
      setClienteTelefone(value)
    }
  }
  useEffect(()=>{
    const enviarPedido = document.getElementById('pedidoPeloZap')
    enviarPedido.addEventListener('onclick', () => {window.open(url, '_blank');})
  },[])
  return(<>
    <div className="form-cliente">
    <Form>
    <Form.Group className="mb-3">
      <Form.Label>Nome</Form.Label>
      <Form.Control type="text" placeholder="Digite seu nome"
        onChange={changeCliente} name="nome" />
      <Form.Text className="text-muted">
        Escreva seu primeiro nome.
      </Form.Text>
    </Form.Group>
    <Form.Group className="mb-3">
        <Form.Label>Telefone</Form.Label>
        <Form.Control type="number" placeholder="Telefone"
         onChange={changeCliente} name="telefone" />
      </Form.Group>
      <Form.Text className="text-muted">
        Escreva seu telefone.
      </Form.Text>
    </Form>
    </div>
    <a href={url+' nome: '+clienteName+' telefone: '+clienteTelefone} id="pedidoPeloZap">
      <img src={logoZap}  alt="logoZap enviar pedido" />
    </a>
  </>
  )
}
export default FormCliente
